
// import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext} from 'pure-react-carousel';
import './carousel.css';


export default function InspirationScreen(){
    return (

        <div className="Home fadein">

            <div className="row center">
                        <img height="300px"  src="https://cdn.vox-cdn.com/thumbor/yLCS5rcJCK-SncthSHanzIRxK9k=/1400x0/filters:no_upscale()/cdn.vox-cdn.com/uploads/chorus_asset/file/11526353/LoveMyself_BTS_1.jpg" alt="bts"></img>
                        <img height="300px"  src="https://cdn.statically.io/img/i.pinimg.com/originals/0f/e2/56/0fe256d41dfdc4208a13076c0a83edd6.jpg" alt="bts"></img>
                
                        <img height="300px"  src="https://miro.medium.com/max/768/1*hEPpjhKRMgCt_UOUao88iA.jpeg" alt="bts"></img>
                        <img height="300px"  src="https://www.getrightmaine.com/wp-content/uploads/2020/09/quotes-pin-by-amber-kiely-on-bts-namjoon-lyrics-qoutes-fantastic-photo.jpg" alt="bts"></img>
                        <img height="300px"  src="https://qph.fs.quoracdn.net/main-qimg-45d6dc5c8397d8f2c348a5b46e7a2e34" alt="bts"></img>
                        <img height="300px"  src="https://www.somagnews.com/wp-content/uploads/2020/06/2020-BTS-FESTA-PHOTO-COLLECTION-19-e1591395159749.jpg" alt="bts"></img>
                        <img height="300px"  src="https://thebiaslistcom.files.wordpress.com/2017/11/bts-mic-drop-steve-aoki-remix.jpg" alt="bts"></img>
                        <img height="300px"  src="https://pm1.narvii.com/6961/d9efcd1c821bd411952492590c925592808d1f1br1-2048-1366v2_uhq.jpg" alt="bts"></img>
                        <br></br>
                        


                        <p>ARMY. Ah really, I worried a lot before coming on the stage. I always wan t to show you guys the best image, because I want to show you an image of someone who does not make mistakes, every time before I get on stage. I clenched my heart, really, and get ready for the stage. Really, this award... I... would have cried if I got this award and cried if I didn't this year. Because we worked so hard. And because we received so much love from you guys. We really wanted to give that back to you. I really thank you and I want to say thank you to the members whom I am sharing this moment. Thank you, I love you. - J-Hope
                        </p>
            </div>
            <div className="row center">
                            <iframe width = "500px" height="300" src="https://youtube.com/embed/gbx2TlHNz48?t=104" title="MAMA 2018"allowfullscreen></iframe>
            </div>
        </div>
    )
}